import AxiosProvider from '@/app/utils/api/axios-provider';

export default {
  getDataSourceSegmentsByDataSourceName(clientId: number, dataSourceName: string) {
    return AxiosProvider.amsApiClient.get(
      `/clients/${clientId}/datasource-segments?datasourceName=${dataSourceName}`
    );
  },
};
